export default __webpack_public_path__ + "static/media/joylife-pedia.1a0aab88.jpg";